import React, { useState } from "react";
import Cookies from "js-cookie";
import CoinsAllocation from "../../admin/gamification/coinsAllocation";
import {
  createCoins,
  updateCoins,
  getCoins,
} from "../../../helper/apicalls/gamification";
import GlobalLoader from "../../common/GlobalLoader";
import "../../../styles/admin/gamification.scss";
import SuccessPopup from "../../common/SuccessPopup";

const Gamification = () => {
  const [activeTab, setActiveTab] = useState("coins");
  const [loader, setLoader] = useState(false);
  const [successOpen, setSuccessOpen] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [coinsState, setCoinsState] = useState({});
  const [experienceState, setExperienceState] = useState({});
  const [popupType, setPopupType] = useState("success");

  const currentState = activeTab === "coins" ? coinsState : experienceState;
  const currentSetState =
    activeTab === "coins" ? setCoinsState : setExperienceState;

  const handleSave = async () => {
    const token = Cookies.get("admin_token");
    if (!token) return;

    setLoader(true);

    try {
      const currentState = activeTab === "coins" ? coinsState : experienceState;
      for (const [courseId, settings] of Object.entries(currentState)) {
        const getValue = (key) => {
          const item = settings.find((s) => s.key === key);
          const fieldName = activeTab === "experience" ? "xp" : "coins";
          return item?.enabled ? Number(item[fieldName] || 0) : 0;
        };

        let payload;

        if (activeTab === "coins") {
          payload = {
            login_coins: getValue("login"),
            streak_coins: getValue("streak"),
            page_completion_coins: getValue("page_completion"),
            quiz_completion_coins: getValue("quiz"),
            test_completion_coins: getValue("test"),
          };
        } else {
          payload = {
            login_xp: getValue("login"),
            streak_xp: getValue("streak"),
            page_completion_xp: getValue("page_completion"),
            quiz_completion_xp: getValue("quiz"),
            test_completion_xp: getValue("test"),
          };
        }

        const existingData = await getCoins(token, courseId, activeTab);

        const hasExisting =
          Array.isArray(existingData) && existingData.length > 0;

        if (hasExisting) {
          await updateCoins(payload, token, courseId, activeTab);
          setPopupType("success");
          setSuccessOpen(true);
          setSuccessMsg(`${activeTab} settings updated successfully!`);
        } else {
          await createCoins({ course: courseId, ...payload }, token, activeTab);
          setSuccessOpen(true);
          setPopupType("success");
          setSuccessMsg(`${activeTab} settings created successfully!`);
        }
      }
    } catch (error) {
      console.error("Save failed:", error);
      alert("Save failed");
    } finally {
      setLoader(false);
    }
  };

  return (
    <>
      {successOpen && (
        <SuccessPopup
          open={successOpen}
          onClose={() => setSuccessOpen(false)}
          message={successMsg}
          type={popupType}
        />
      )}
      {loader && <GlobalLoader visible text="Saving..." />}

      <div className="gamification-page">
        <div className="gamification-header">
          <div className="header-left">Gamification</div>

          <div className="header-center">
            <button
              className={`tab ${activeTab === "coins" ? "active" : ""}`}
              onClick={() => setActiveTab("coins")}
            >
              Coins
            </button>

            <button
              className={`tab ${activeTab === "experience" ? "active" : ""}`}
              onClick={() => setActiveTab("experience")}
            >
              Experience
            </button>
          </div>

          <div className="header-right">
            <button className="save-btn" onClick={handleSave}>
              Save Changes
            </button>
          </div>
        </div>

        <div className="gamification-content">
          <CoinsAllocation
            type={activeTab}
            state={currentState}
            setState={currentSetState}
          />
        </div>
      </div>
    </>
  );
};

export default Gamification;
